import React from 'react';

const HiddenStepsPlaceholder = ({ pathTitle }) => (
  <div className="HiddenStepsPlaceholder">
    <h3 className="HiddenStepsPlaceholder-title d-b">
      {pathTitle
        ? t('paths.hidden_placeholder.title_with_path', { path: pathTitle })
        : t('paths.hidden_placeholder.title')}
    </h3>
    <p className="HiddenStepsPlaceholder-description">
      <span>{t('paths.hidden_placeholder.description')}</span>
    </p>
  </div>
);

export default HiddenStepsPlaceholder;
